(function () {
  'use strict';

  var STICKY_VISIBLE_CLASS = 'pv-sticky-bar--visible';
  var DETAILS_OPEN_CLASS = 'pv-sticky-bar__details--open';
  var TOGGLE_OPEN_CLASS = 'pv-sticky-bar__toggle--open';
  var FLOATING_WIDGET_SELECTORS = [
    '#podium-bubble',
    'iframe.podium-iframe',
    'iframe[data-cy="podium-website-widget-iframe"]',
    '.rebuy-widget',
    '.rebuy-floating-widget'
  ];
  var floatingWidgetStack = [];

  function storeFloatingWidgetStyle(el, key) {
    return {
      value: el.style.getPropertyValue(key),
      priority: el.style.getPropertyPriority(key)
    };
  }

  function restoreFloatingWidgetStyle(el, key, stored) {
    if (stored.priority) {
      el.style.setProperty(key, stored.value, stored.priority);
    } else if (stored.value) {
      el.style.setProperty(key, stored.value);
    } else {
      el.style.removeProperty(key);
    }
  }

  function getFloatingWidgetElements() {
    var elements = [];

    FLOATING_WIDGET_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (elements.indexOf(el) === -1) {
          elements.push(el);
        }
      });
    });

    var podiumBubble = document.getElementById('podium-bubble');
    var parent = podiumBubble ? podiumBubble.parentElement : null;

    while (parent && parent !== document.body) {
      if (elements.indexOf(parent) === -1) {
        elements.push(parent);
      }
      parent = parent.parentElement;
    }

    return elements;
  }

  function setFloatingWidgetsBehindSticky(isBehind) {
    if (isBehind) {
      var elements = getFloatingWidgetElements();
      var trackedElements = floatingWidgetStack.map(function (item) {
        return item.el;
      });

      elements.forEach(function (el) {
        if (trackedElements.indexOf(el) === -1) {
          floatingWidgetStack.push({
            el: el,
            zIndex: storeFloatingWidgetStyle(el, 'z-index')
          });
        }

        el.style.setProperty('z-index', '1', 'important');
      });
      return;
    }

    floatingWidgetStack.forEach(function (item) {
      restoreFloatingWidgetStyle(item.el, 'z-index', item.zIndex);
    });

    floatingWidgetStack = [];
  }

  function mountStickyBar(stickyBar) {
    if (stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }
  }

  function bringStickyBarToFront(stickyBar) {
    mountStickyBar(stickyBar);
    document.body.appendChild(stickyBar);
  }

  function init() {
    var stickyBar = document.getElementById('pvStickyBar');
    var productForm = document.getElementById('addToBagForm');
    var productSection = document.getElementById('product');
    var atcButton = document.getElementById('btnAddToBag');

    if (!stickyBar || !productForm || !productSection || !atcButton) {
      return;
    }

    mountStickyBar(stickyBar);

    var stickySelects = stickyBar.querySelectorAll('.js-pv-sticky-select');
    var stickyAtc = stickyBar.querySelector('.js-pv-sticky-atc');
    var stickyAtcText = stickyBar.querySelector('.js-pv-sticky-atc-text');
    var stickyToggle = stickyBar.querySelector('.js-pv-sticky-toggle');
    var stickyDetails = stickyBar.querySelector('.js-pv-sticky-details');
    var stickyImages = stickyBar.querySelectorAll('.js-pv-sticky-image, .js-pv-sticky-image-desktop');
    var priceOriginalEls = stickyBar.querySelectorAll('.js-pv-sticky-price-original, .js-pv-sticky-price-original-mobile');
    var priceCompareEls = stickyBar.querySelectorAll('.js-pv-sticky-price-compare, .js-pv-sticky-price-compare-mobile');
    var isSyncing = false;

    function isMobileSticky() {
      return window.innerWidth <= 767;
    }

    function setStickyVisible(isVisible) {
      if (isVisible) {
        bringStickyBarToFront(stickyBar);
        if (isMobileSticky() && stickyDetails) {
          setDetailsOpen(true);
        }
      }

      stickyBar.classList.toggle(STICKY_VISIBLE_CLASS, isVisible);
      stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      document.body.classList.toggle('pv-sticky-bar-active', isVisible);
      setFloatingWidgetsBehindSticky(isVisible);
    }

    function setDetailsOpen(isOpen) {
      if (!stickyDetails || !stickyToggle) return;
      stickyDetails.classList.toggle(DETAILS_OPEN_CLASS, isOpen);
      stickyToggle.classList.toggle(TOGGLE_OPEN_CLASS, isOpen);
      stickyToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function getMainInputs() {
      return productForm.querySelectorAll('.js-input');
    }

    function findRadioForOption(optionName, value) {
      var inputs = productForm.querySelectorAll('.js-input[name="options[' + optionName + ']"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          return inputs[i];
        }
      }
      return null;
    }

    function syncStickyFromMain() {
      if (isSyncing) return;
      isSyncing = true;

      stickySelects.forEach(function (select) {
        var optionName = select.dataset.optionName;
        var checked = productForm.querySelector('.js-input[name="options[' + optionName + ']"]:checked');
        if (checked) {
          select.value = checked.value;
        }
      });

      syncPriceFromMain();
      syncAtcFromMain();
      isSyncing = false;
    }

    function syncPriceFromMain() {
      var mainPrice = productSection.querySelector('.js-price-original');
      var mainCompare = productSection.querySelector('.js-price-compare');

      if (!mainPrice) return;

      priceOriginalEls.forEach(function (el) {
        el.textContent = mainPrice.textContent;
      });

      var hasCompare = mainCompare && mainCompare.style.display !== 'none' && mainCompare.textContent.trim() !== '';

      priceCompareEls.forEach(function (el) {
        if (hasCompare) {
          el.textContent = mainCompare.textContent;
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', 'hidden');
        }
      });
    }

    function syncAtcFromMain() {
      stickyAtc.disabled = atcButton.disabled;
      stickyAtcText.textContent = document.getElementById('btnAddToBagText').textContent;
    }

    function syncStickyImage() {
      if (!stickyImages.length || !window.SDG || !SDG.Data || !SDG.Data.productJson) return;

      var hiddenId = productForm.querySelector('.js-hidden-id');
      if (!hiddenId) return;

      var variantId = Number(hiddenId.value);
      var variant = SDG.Data.productJson.variants.find(function (v) {
        return v.id === variantId;
      });

      if (!variant) return;

      var imageSrc = '';

      if (variant.featured_image && variant.featured_image.src) {
        imageSrc = variant.featured_image.src;
      } else if (SDG.Data.productJson.featured_image) {
        imageSrc = SDG.Data.productJson.featured_image;
      }

      if (!imageSrc) return;

      stickyImages.forEach(function (image) {
        image.src = imageSrc;
      });
    }

    function onStickySelectChange(event) {
      if (isSyncing) return;

      var select = event.target;
      var optionName = select.dataset.optionName;
      var value = select.value;
      var radio = findRadioForOption(optionName, value);

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function onMainInputChange() {
      syncStickyFromMain();
      syncStickyImage();
    }

    function onStickyAtcClick() {
      if (atcButton.disabled) return;
      atcButton.click();
    }

    function onStickyToggleClick() {
      var isOpen = stickyDetails.classList.contains(DETAILS_OPEN_CLASS);
      setDetailsOpen(!isOpen);
    }

    stickySelects.forEach(function (select) {
      select.addEventListener('change', onStickySelectChange);
    });

    getMainInputs().forEach(function (input) {
      input.addEventListener('change', onMainInputChange);
    });

    stickyAtc.addEventListener('click', onStickyAtcClick);

    if (stickyToggle) {
      stickyToggle.addEventListener('click', onStickyToggleClick);
    }

    var atcPassed = false;
    var footerInView = false;

    function updateStickyVisibility() {
      setStickyVisible(atcPassed && !footerInView);
    }

    function hasScrolledPastAtc(entry) {
      return !entry.isIntersecting && entry.boundingClientRect.top < 0;
    }

    var showObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          atcPassed = hasScrolledPastAtc(entry);
          updateStickyVisibility();
        });
      },
      { threshold: 0 }
    );

    showObserver.observe(atcButton);

    var footer = document.querySelector('.footer');
    if (footer) {
      var hideObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        { threshold: 0 }
      );

      hideObserver.observe(footer);
    }

    var priceTarget = productSection.querySelector('.js-price-original');
    if (priceTarget && window.MutationObserver) {
      var priceObserver = new MutationObserver(syncPriceFromMain);
      priceObserver.observe(priceTarget, { childList: true, characterData: true, subtree: true });
    }

    var atcObserverTarget = document.getElementById('btnAddToBagText');
    if (atcObserverTarget && window.MutationObserver) {
      var atcObserver = new MutationObserver(syncAtcFromMain);
      atcObserver.observe(atcObserverTarget, { childList: true, characterData: true, subtree: true });
    }

    if (atcButton) {
      atcButton.addEventListener('change', syncAtcFromMain);
      var atcAttrObserver = new MutationObserver(syncAtcFromMain);
      atcAttrObserver.observe(atcButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    syncStickyFromMain();
    syncStickyImage();

    if (stickyToggle && stickyDetails && stickyDetails.classList.contains(DETAILS_OPEN_CLASS)) {
      stickyToggle.classList.add(TOGGLE_OPEN_CLASS);
    }

    var floatingWidgetObserver = new MutationObserver(function () {
      if (document.body.classList.contains('pv-sticky-bar-active')) {
        setFloatingWidgetsBehindSticky(true);
      }
    });

    floatingWidgetObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
